export default {
  weddings: {},
  weddingCursor: null,
  userWeddingCursor: null
}
